"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var warned = {};
var warnOnce = function (id) {
    var data = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        data[_i - 1] = arguments[_i];
    }
    if (warned[id]) {
        return;
    }
    warned[id] = true;
    console.warn.apply(console, data);
};
exports.default = warnOnce;
